export const environment = {
  production: true,
  base_url: 'https://snaitech.re-learn.it/index.php/',
  relearnit_base_url: 'https://snaitech.re-learn.it/backend'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts